import pick from 'lodash/pick';

export const didComponentValueUpdate = (value1, value2) => {
  if (value1 !== value2) {
    if (Object.is(value1, NaN) && Object.is(value2, NaN)) {
      // If both values are NaN then they will never be the same since NaN !== Nan.
    } else {
      // This will not cause an infinite loop since value1 === value2 once the new state has been set.
      return true;
    }

    return false;
  }
};

// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img
const VALID_DOM_IMG_ATTRIBUTES = [
  'style',
  'className',
  'src',
  'srcset',
  'alt',
  'crossorigin',
  'decoding',
  'width',
  'height',
  'ismap',
  'loading',
  'referrerpolicy',
  'sizes',
  'usemap'
]
export const getValidDomImgAttributes = (props) => pick(props, VALID_DOM_IMG_ATTRIBUTES);
